import { fmtCLP } from "../../utils/formato";

export default function MobileFooter({
  pedido,
  totalFinal,
  enviando,
  cajaAbierta,
  onOpenCart,
  onConfigureDescuento,
  onEnviarPedido,
  onGuardarBorrador,
}) {
  return (
    <div className="pos-mobile-footer" aria-hidden="true">
      <div
        className="pos-mobile-footer__left"
        role="button"
        tabIndex={0}
        onClick={() => (pedido ?? []).length > 0 && onOpenCart()}
        onKeyDown={(e) =>
          (e.key === "Enter" || e.key === " ") &&
          (pedido ?? []).length > 0 &&
          onOpenCart()
        }
      >
        <span className="pos-mobile-footer__label">
          {(pedido ?? []).length > 0
            ? `${pedido.length} ítem${pedido.length === 1 ? "" : "s"}`
            : "Sin ítems"}
        </span>
        {(pedido ?? []).length > 0 && (
          <div className="pos-mobile-footer__links">
            <button
              type="button"
              className="pos-mobile-footer__link"
              onClick={(e) => {
                e.stopPropagation();
                onConfigureDescuento();
              }}
            >
              Descuento
            </button>
            <button
              type="button"
              className="pos-mobile-footer__link"
              onClick={onOpenCart}
            >
              Ver pedido
            </button>
          </div>
        )}
      </div>

      <div className="pos-mobile-footer__center">
        <span className="pos-mobile-footer__total">{fmtCLP(totalFinal)}</span>
        <span className="pos-mobile-footer__currency"> CLP</span>
      </div>

      <button
        type="button"
        className="pos-mobile-footer__btn"
        onClick={onEnviarPedido}
        disabled={enviando || cajaAbierta === false || (pedido ?? []).length === 0}
      >
        {enviando ? "Enviando…" : "Enviar"}
      </button>
      <button
        type="button"
        className="pos-mobile-footer__draft"
        onClick={onGuardarBorrador}
        disabled={enviando || (pedido ?? []).length === 0}
      >
        Borrador
      </button>
    </div>
  );
}
